<template>
  <v-modal name="subscription" class="modal" height="auto" :width="450" close-button
    @before-open="data = $event.params.data">
    <in-app-product-header :icon="data.icon_uri" :name="$t(data.reseller ? 'SUBSCRIPTION_NAME_WITH_RESELLER' : 'SUBSCRIPTION_NAME',
      { name: data.name, provider: data.provider, reseller: data.reseller }
    )" :description="data.description" />

    <ul class="info">
      <li>
        <strong>{{ $t('STATUS') }}</strong>
        <span class="status g-status"
          :class="/active|cancelled/.test(data.status) ? 'g-status_success' : 'g-status_error'">
          {{ data.status_translated }}
        </span>
      </li>
      <li>
        <strong>{{ $t('TYPE') }}</strong>
        <span>{{ data.type_translated }}</span>
      </li>
      <li>
        <strong>{{ $t('DEVICE') }}</strong>
        <span>{{ data.nice_device_model }}</span>
      </li>
      <li>
        <strong>{{ $t('PRICE') }}</strong>
        <span>{{ formatCurrency(data.price_cents_eur) }}</span>
      </li>
      <li>
        <strong>{{ expirationLabel }}</strong>
        <span>{{ new Date(data.expires_at * 1000).toLocaleDateString() }}</span>
      </li>
      <li>
        <a :href="data.support_uri" target="_blank">{{ $t("GET_SUPPORT") }}</a>

        |
        <a v-if="data.manage_uri" :href="data.manage_uri" class="g-pseudo-link cancel-button" target="_blank">
          {{ $t('MANAGE_SUBSCRIPTION') }}
        </a>

      </li>
    </ul>
  </v-modal>
</template>

<script>
import VModal from '@/components/VModal.vue';
import InAppProductHeader from '@/components/InAppProductHeader.vue';
import formatCurrency from '@/utils/formatCurrency';

export default {
  components: {
    VModal,
    InAppProductHeader,
  },
  data() {
    return {
      data: {},
    };
  },
  computed: {
    expirationLabel() {
      if (this.data.status === 'active') {
        return this.$t('SUBSCRIPTION_RENEWS');
      }

      if (Date.now() < new Date(this.data.expires_at * 1000)) {
        return this.$t('SUBSCRIPTION_EXPIRES');
      }

      return this.$t('SUBSCRIPTION_EXPIRED');
    },
  },
  methods: {
    formatCurrency,
  },
};
</script>

<style lang="scss" scoped>
.modal {
  padding: 15px;
}

.header {
  margin-bottom: 15px;
}

.support {
  position: relative;
  top: 2px;
  left: 1px;
}

.status {
  font-size: 14px;
  word-break: break-word;
}

.status,
.type {
  word-break: break-word;
}

.info {
  margin-top: 15px;

  li:not(:last-child) {
    margin-bottom: 10px;
  }

  strong:first-child {
    margin-right: 5px;
  }
}

.cancel-button {
  display: inline-flex;
  align-items: center;
  gap: 5px;

  &__loader {
    width: auto;
  }
}
</style>
